import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import toast from 'components/shared/toast/toast'
import { ADD_STOCK, DELETE_STOCK, GET_ALL_LOGS_NEW, GET_STOCK, GET_STOCK_BY_ID, LIVE_STOCKS, LOGS } from 'services/apiEndpoints'
import { privateDelete, privateGet, privateGetId, privatePost, privateRequestDotNet } from 'services/privateRequest'
import publicRequest from 'services/publicRequest'
const initialState = {
    stock: [],
    obj: {},
    load: false,
    fil: [],
    live: {},
    logs: [],
    live_data: false,
    err: false,
    modal: false,
    name: "",
    roles: {
        tracker: false,
        trend: false,
        // admin: false
    }
}
export const stockSlice = createSlice({
    name: 'stock',
    initialState,
    reducers: {
        setName: (state, action) => {
            state.name = action.payload
        },
        setRole: (state, action) => {
            state.roles = action.payload
        },
        setModal: (state, action) => {
            state.modal = action.payload
        },
        filtered: (state, action) => {
            if (action.payload) {
                state.fil
                    = action.payload
            } else {
                state.fil = []
            }
        },

        delfiltered: (state, action) => {
            state.fil = state.fil.filter((e) => e.id !== action.payload)
        },

    },
    extraReducers: (builder) => {
        builder.addCase(getStock.fulfilled, (state, action) => {
            state.stock = action.payload
            state.load = false

        }).addCase(getStock.pending, (state, action) => {
            state.load = true

        }).addCase(getStock.rejected, (state, action) => {
            state.load = false

        })
            .addCase(addStock.fulfilled, (state, action) => {
                // state.stock.push(action.payload)
                state.load = false
                state.err = false
            }).addCase(addStock.pending, (state, action) => {
                state.load = true
                state.err = false
            }).addCase(addStock.rejected, (state, action) => {
                state.load = false
                state.err = true
            })
            .addCase(deleteStock.fulfilled, (state, action) => {
                // state.stock = state.stock.filter((e) => e.id !== action.payload)
                state.load = false
                state.obj = null
                // state.live_data = false  
                state.live = null
                state.name = ""
            }).addCase(deleteStock.pending, (state, action) => {
                state.load = true
            }).addCase(deleteStock.rejected, (state, action) => {
                state.load = false
            })
            .addCase(getStockById.fulfilled, (state, action) => {
                state.obj = action.payload
                state.load = false
                state.err = false
            }).addCase(getStockById.pending, (state, action) => {
                state.load = true
                state.err = false
            }).addCase(getStockById.rejected, (state, action) => {
                state.load = false
                state.err = true
            }).addCase(liveStock.fulfilled, (state, action) => {
                state.live = action.payload
                state.load = false
                state.err = false
                state.live_data = false
            })
            .addCase(liveStock.rejected, (state, action) => {
                state.live_data = true
            }).addCase(liveStock.pending, (state, action) => {
                state.live_data = true

            }).addCase(getLogs.fulfilled, (state, action) => {
                state.logs = action.payload
                state.load = false
                state.err = false

            })
            .addCase(getLogs.rejected, (state, action) => {
                state.load = false
                state.err = true
            }).addCase(getLogs.pending, (state, action) => {
                state.load = true
                state.err = false

            })
    },
})
export const getStock = createAsyncThunk(
    'stock/get',
    async (thunkAPI) => {
        let data = await privateGet(GET_STOCK)
        return data.data
    }
)
export const liveStock = createAsyncThunk(
    'stocklive/get',
    async (thunkAPI, { rejectWithValue, dispatch }) => {
        try {
            let data = await privateGetId(`${LIVE_STOCKS}`, thunkAPI)
            return data.data
        } catch (err) {
            toast.error(err.message)
        }
    }
)
export const getStockById = createAsyncThunk(
    'stock/get/id',
    async (thunkAPI) => {
        try {
            let data = await privateGetId(`${GET_STOCK_BY_ID}`, thunkAPI)
            return data.data
        } catch (err) {
            toast.error(err.message)
        }
    }
)
export const addStock = createAsyncThunk(
    'stock/add',
    async (thunkAPI, { rejectWithValue, dispatch }) => {

        try {
            let data = await privatePost(ADD_STOCK, thunkAPI)
            toast.success("Stock Added Successfully")
            dispatch(getStock())
            return data.data
        } catch (err) {
            // toast.error(err.response.data.detail)
        }
    }
)
// export const deleteStock = createAsyncThunk(
//     'stock/delete',
//     async ({ id, navigate }, { rejectWithValue, dispatch }) => {
//         try {
//             let data = await privateDelete(`${DELETE_STOCK}/${id}`);
//             toast.success('Deleted Successfully');
//             dispatch(getStock());
//             navigate('/stocktrend'); // Navigate to the desired path
//             return data; // Return the received data if needed
//         } catch (err) {
//             toast.error(err.message);
//             return rejectWithValue(err.message); // Return the error message if needed
//         }
//     }
// );

export const deleteStock = createAsyncThunk(
    'stock/delete',
    async (thunkAPI, { rejectWithValue, dispatch }) => {
        try {
            let data = await privateDelete(`${DELETE_STOCK}`, thunkAPI)
            toast.success("Deleted Successfully")
            dispatch(getStock())
            return thunkAPI
        } catch (err) {
            toast.error(err.message)
        }
    }
)
export const getLogs = createAsyncThunk(
    'logs/get',
    async (thunkAPI, { rejectWithValue, dispatch }) => {
        try {
            let data = await privateRequestDotNet.get(`${GET_ALL_LOGS_NEW}`)
            return data.data
        } catch (err) {
            toast.error(err.message)
        }
    }
)

export const { filtered, delfiltered, setName, setRole, setModal } = stockSlice.actions

export default stockSlice.reducer